import { searchableComputedProperty, SB } from '@play-co/replicant';
import { State } from 'src/replicant/State';
import { getMastersLeagueDifficultyBucketForLeague } from './leagues.getters';

export const leagueProperties = {
  /**
   * The league scores
   */
  leagues: searchableComputedProperty(
    SB.array(
      SB.object({
        leagueId: SB.string(),
        phase: SB.int(),
        score: SB.int(),
        modifiedAt: SB.int(),
        isV2: SB.boolean(),
        mastersLeagueDifficultyBucket: SB.string(),
      }),
    ),
    (user: State) => {
      const {
        match2: { leagues },
      } = user;
      return Object.entries(leagues).reduce(
        (acc, [leagueId, league]) => {
          acc.push({
            leagueId,
            // On original leagues (v1), phase is essentially the score + 1.
            phase: league.phase ?? league.score + 1,
            score: league.score,
            modifiedAt: league.modifiedAt,
            // Champions League V2 was removed (#10056) and its only event
            // ('3550') is retired, but its entries must keep indexing as v2
            // (the old detector: event whitelist plus phase > 1) so they stay
            // excluded from v1 scoreboards, which filter on isV2 false.
            isV2: leagueId === '3550' && (league.phase ?? 1) > 1,
            // Keep historical cohorts searchable until their final ranks are claimed.
            mastersLeagueDifficultyBucket:
              getMastersLeagueDifficultyBucketForLeague(user, leagueId),
          });
          return acc;
        },
        [] as {
          leagueId: string;
          phase: number;
          score: number;
          modifiedAt: number;
          isV2: boolean;
          mastersLeagueDifficultyBucket: string;
        }[],
      );
    },
  ),
  /**
   * Get the number of top 3 medals, excluding participation ones
   */
  leaguesAllTimeScore: searchableComputedProperty(
    SB.int(),
    ({ match2: { leaguesAllTimeScore } }: State) => {
      return leaguesAllTimeScore;
    },
  ),
};
